const procesosCafe = {
  LAVADO: 1,
  HONEY: 2,
  OTRO: 3,
  NATURAL: 4,
  NO_APLICA: 5,
  SEMILAVADO: 6,
  FERMENTACION_CONTROLADA: 7,
  LAVADO_CACAO: 8,
  FERMENTADO: 9,
};

export { procesosCafe };
